//@ts-nocheck
import { PageRequest, PageResponse } from "../../../cosmos/base/query/v1beta1/pagination";
import { Params } from "./params";
import { StakeStorage } from "./stake_storage";
import { EpochDetails } from "./epoch_details";
import { FixatedParams } from "./fixated_params";
import { ProviderMetadata } from "./provider_metadata";
import { BinaryReader, BinaryWriter } from "../../../binary";
import { isSet } from "../../../helpers";
import { GlobalDecoderRegistry } from "../../../registry";
function createBaseQueryParamsRequest() {
    return {};
}
export const QueryParamsRequest = {
    typeUrl: "/lavanet.lava.epochstorage.QueryParamsRequest",
    is(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
    fromAmino(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return QueryParamsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryParamsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryParamsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryParamsRequest",
            value: QueryParamsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryParamsRequest.typeUrl, QueryParamsRequest);
function createBaseQueryParamsResponse() {
    return {
        params: Params.fromPartial({})
    };
}
export const QueryParamsResponse = {
    typeUrl: "/lavanet.lava.epochstorage.QueryParamsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params.is(o.params));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params.isSDK(o.params));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params.isAmino(o.params));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.params !== undefined) {
            Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: isSet(object.params) ? Params.fromJSON(object.params) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryParamsResponse();
        if (object.params !== undefined && object.params !== null) {
            message.params = Params.fromAmino(object.params);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.params = message.params ? Params.toAmino(message.params) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryParamsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryParamsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryParamsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryParamsResponse",
            value: QueryParamsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryParamsResponse.typeUrl, QueryParamsResponse);
function createBaseQueryGetStakeStorageRequest() {
    return {
        index: ""
    };
}
export const QueryGetStakeStorageRequest = {
    typeUrl: "/lavanet.lava.epochstorage.QueryGetStakeStorageRequest",
    is(o) {
        return o && (o.$typeUrl === QueryGetStakeStorageRequest.typeUrl || typeof o.index === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryGetStakeStorageRequest.typeUrl || typeof o.index === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryGetStakeStorageRequest.typeUrl || typeof o.index === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.index !== "") {
            writer.uint32(10).string(message.index);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGetStakeStorageRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.index = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            index: isSet(object.index) ? String(object.index) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.index !== undefined && (obj.index = message.index);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGetStakeStorageRequest();
        message.index = object.index ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryGetStakeStorageRequest();
        if (object.index !== undefined && object.index !== null) {
            message.index = object.index;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.index = message.index === "" ? undefined : message.index;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryGetStakeStorageRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryGetStakeStorageRequest.decode(message.value);
    },
    toProto(message) {
        return QueryGetStakeStorageRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryGetStakeStorageRequest",
            value: QueryGetStakeStorageRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryGetStakeStorageRequest.typeUrl, QueryGetStakeStorageRequest);
function createBaseQueryGetStakeStorageResponse() {
    return {
        stakeStorage: StakeStorage.fromPartial({})
    };
}
export const QueryGetStakeStorageResponse = {
    typeUrl: "/lavanet.lava.epochstorage.QueryGetStakeStorageResponse",
    is(o) {
        return o && (o.$typeUrl === QueryGetStakeStorageResponse.typeUrl || StakeStorage.is(o.stakeStorage));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryGetStakeStorageResponse.typeUrl || StakeStorage.isSDK(o.stakeStorage));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryGetStakeStorageResponse.typeUrl || StakeStorage.isAmino(o.stakeStorage));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.stakeStorage !== undefined) {
            StakeStorage.encode(message.stakeStorage, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGetStakeStorageResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.stakeStorage = StakeStorage.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            stakeStorage: isSet(object.stakeStorage) ? StakeStorage.fromJSON(object.stakeStorage) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.stakeStorage !== undefined && (obj.stakeStorage = message.stakeStorage ? StakeStorage.toJSON(message.stakeStorage) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGetStakeStorageResponse();
        message.stakeStorage = object.stakeStorage !== undefined && object.stakeStorage !== null ? StakeStorage.fromPartial(object.stakeStorage) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryGetStakeStorageResponse();
        if (object.stakeStorage !== undefined && object.stakeStorage !== null) {
            message.stakeStorage = StakeStorage.fromAmino(object.stakeStorage);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.stakeStorage = message.stakeStorage ? StakeStorage.toAmino(message.stakeStorage) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryGetStakeStorageResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryGetStakeStorageResponse.decode(message.value);
    },
    toProto(message) {
        return QueryGetStakeStorageResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryGetStakeStorageResponse",
            value: QueryGetStakeStorageResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryGetStakeStorageResponse.typeUrl, QueryGetStakeStorageResponse);
function createBaseQueryAllStakeStorageRequest() {
    return {
        pagination: undefined
    };
}
export const QueryAllStakeStorageRequest = {
    typeUrl: "/lavanet.lava.epochstorage.QueryAllStakeStorageRequest",
    is(o) {
        return o && o.$typeUrl === QueryAllStakeStorageRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryAllStakeStorageRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryAllStakeStorageRequest.typeUrl;
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.pagination !== undefined) {
            PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllStakeStorageRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: isSet(object.pagination) ? PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllStakeStorageRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryAllStakeStorageRequest();
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = PageRequest.fromAmino(object.pagination);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.pagination = message.pagination ? PageRequest.toAmino(message.pagination) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryAllStakeStorageRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryAllStakeStorageRequest.decode(message.value);
    },
    toProto(message) {
        return QueryAllStakeStorageRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryAllStakeStorageRequest",
            value: QueryAllStakeStorageRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryAllStakeStorageRequest.typeUrl, QueryAllStakeStorageRequest);
function createBaseQueryAllStakeStorageResponse() {
    return {
        stakeStorage: [],
        pagination: undefined
    };
}
export const QueryAllStakeStorageResponse = {
    typeUrl: "/lavanet.lava.epochstorage.QueryAllStakeStorageResponse",
    is(o) {
        return o && (o.$typeUrl === QueryAllStakeStorageResponse.typeUrl || Array.isArray(o.stakeStorage) && (!o.stakeStorage.length || StakeStorage.is(o.stakeStorage[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryAllStakeStorageResponse.typeUrl || Array.isArray(o.stakeStorage) && (!o.stakeStorage.length || StakeStorage.isSDK(o.stakeStorage[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryAllStakeStorageResponse.typeUrl || Array.isArray(o.stakeStorage) && (!o.stakeStorage.length || StakeStorage.isAmino(o.stakeStorage[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.stakeStorage) {
            StakeStorage.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllStakeStorageResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.stakeStorage.push(StakeStorage.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            stakeStorage: Array.isArray(object?.stakeStorage) ? object.stakeStorage.map((e) => StakeStorage.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.stakeStorage) {
            obj.stakeStorage = message.stakeStorage.map(e => e ? StakeStorage.toJSON(e) : undefined);
        }
        else {
            obj.stakeStorage = [];
        }
        message.pagination !== undefined && (obj.pagination = message.pagination ? PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllStakeStorageResponse();
        message.stakeStorage = object.stakeStorage?.map(e => StakeStorage.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryAllStakeStorageResponse();
        message.stakeStorage = object.stakeStorage?.map(e => StakeStorage.fromAmino(e)) || [];
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = PageResponse.fromAmino(object.pagination);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.stakeStorage) {
            obj.stakeStorage = message.stakeStorage.map(e => e ? StakeStorage.toAmino(e) : undefined);
        }
        else {
            obj.stakeStorage = message.stakeStorage;
        }
        obj.pagination = message.pagination ? PageResponse.toAmino(message.pagination) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryAllStakeStorageResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryAllStakeStorageResponse.decode(message.value);
    },
    toProto(message) {
        return QueryAllStakeStorageResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryAllStakeStorageResponse",
            value: QueryAllStakeStorageResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryAllStakeStorageResponse.typeUrl, QueryAllStakeStorageResponse);
function createBaseQueryGetEpochDetailsRequest() {
    return {};
}
export const QueryGetEpochDetailsRequest = {
    typeUrl: "/lavanet.lava.epochstorage.QueryGetEpochDetailsRequest",
    is(o) {
        return o && o.$typeUrl === QueryGetEpochDetailsRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryGetEpochDetailsRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryGetEpochDetailsRequest.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGetEpochDetailsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryGetEpochDetailsRequest();
        return message;
    },
    fromAmino(_) {
        const message = createBaseQueryGetEpochDetailsRequest();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return QueryGetEpochDetailsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryGetEpochDetailsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryGetEpochDetailsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryGetEpochDetailsRequest",
            value: QueryGetEpochDetailsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryGetEpochDetailsRequest.typeUrl, QueryGetEpochDetailsRequest);
function createBaseQueryGetEpochDetailsResponse() {
    return {
        epochDetails: EpochDetails.fromPartial({})
    };
}
export const QueryGetEpochDetailsResponse = {
    typeUrl: "/lavanet.lava.epochstorage.QueryGetEpochDetailsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryGetEpochDetailsResponse.typeUrl || EpochDetails.is(o.epochDetails));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryGetEpochDetailsResponse.typeUrl || EpochDetails.isSDK(o.EpochDetails));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryGetEpochDetailsResponse.typeUrl || EpochDetails.isAmino(o.EpochDetails));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.epochDetails !== undefined) {
            EpochDetails.encode(message.epochDetails, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGetEpochDetailsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.epochDetails = EpochDetails.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            epochDetails: isSet(object.epochDetails) ? EpochDetails.fromJSON(object.epochDetails) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.epochDetails !== undefined && (obj.epochDetails = message.epochDetails ? EpochDetails.toJSON(message.epochDetails) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGetEpochDetailsResponse();
        message.epochDetails = object.epochDetails !== undefined && object.epochDetails !== null ? EpochDetails.fromPartial(object.epochDetails) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryGetEpochDetailsResponse();
        if (object.EpochDetails !== undefined && object.EpochDetails !== null) {
            message.epochDetails = EpochDetails.fromAmino(object.EpochDetails);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.EpochDetails = message.epochDetails ? EpochDetails.toAmino(message.epochDetails) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryGetEpochDetailsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryGetEpochDetailsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryGetEpochDetailsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryGetEpochDetailsResponse",
            value: QueryGetEpochDetailsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryGetEpochDetailsResponse.typeUrl, QueryGetEpochDetailsResponse);
function createBaseQueryGetFixatedParamsRequest() {
    return {
        index: ""
    };
}
export const QueryGetFixatedParamsRequest = {
    typeUrl: "/lavanet.lava.epochstorage.QueryGetFixatedParamsRequest",
    is(o) {
        return o && (o.$typeUrl === QueryGetFixatedParamsRequest.typeUrl || typeof o.index === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryGetFixatedParamsRequest.typeUrl || typeof o.index === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryGetFixatedParamsRequest.typeUrl || typeof o.index === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.index !== "") {
            writer.uint32(10).string(message.index);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGetFixatedParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.index = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            index: isSet(object.index) ? String(object.index) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.index !== undefined && (obj.index = message.index);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGetFixatedParamsRequest();
        message.index = object.index ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryGetFixatedParamsRequest();
        if (object.index !== undefined && object.index !== null) {
            message.index = object.index;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.index = message.index === "" ? undefined : message.index;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryGetFixatedParamsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryGetFixatedParamsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryGetFixatedParamsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryGetFixatedParamsRequest",
            value: QueryGetFixatedParamsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryGetFixatedParamsRequest.typeUrl, QueryGetFixatedParamsRequest);
function createBaseQueryGetFixatedParamsResponse() {
    return {
        fixatedParams: FixatedParams.fromPartial({})
    };
}
export const QueryGetFixatedParamsResponse = {
    typeUrl: "/lavanet.lava.epochstorage.QueryGetFixatedParamsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryGetFixatedParamsResponse.typeUrl || FixatedParams.is(o.fixatedParams));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryGetFixatedParamsResponse.typeUrl || FixatedParams.isSDK(o.fixatedParams));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryGetFixatedParamsResponse.typeUrl || FixatedParams.isAmino(o.fixatedParams));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.fixatedParams !== undefined) {
            FixatedParams.encode(message.fixatedParams, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGetFixatedParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fixatedParams = FixatedParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fixatedParams: isSet(object.fixatedParams) ? FixatedParams.fromJSON(object.fixatedParams) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.fixatedParams !== undefined && (obj.fixatedParams = message.fixatedParams ? FixatedParams.toJSON(message.fixatedParams) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGetFixatedParamsResponse();
        message.fixatedParams = object.fixatedParams !== undefined && object.fixatedParams !== null ? FixatedParams.fromPartial(object.fixatedParams) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryGetFixatedParamsResponse();
        if (object.fixatedParams !== undefined && object.fixatedParams !== null) {
            message.fixatedParams = FixatedParams.fromAmino(object.fixatedParams);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.fixatedParams = message.fixatedParams ? FixatedParams.toAmino(message.fixatedParams) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryGetFixatedParamsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryGetFixatedParamsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryGetFixatedParamsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryGetFixatedParamsResponse",
            value: QueryGetFixatedParamsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryGetFixatedParamsResponse.typeUrl, QueryGetFixatedParamsResponse);
function createBaseQueryAllFixatedParamsRequest() {
    return {
        pagination: undefined
    };
}
export const QueryAllFixatedParamsRequest = {
    typeUrl: "/lavanet.lava.epochstorage.QueryAllFixatedParamsRequest",
    is(o) {
        return o && o.$typeUrl === QueryAllFixatedParamsRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryAllFixatedParamsRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryAllFixatedParamsRequest.typeUrl;
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.pagination !== undefined) {
            PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllFixatedParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: isSet(object.pagination) ? PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllFixatedParamsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryAllFixatedParamsRequest();
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = PageRequest.fromAmino(object.pagination);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.pagination = message.pagination ? PageRequest.toAmino(message.pagination) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryAllFixatedParamsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryAllFixatedParamsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryAllFixatedParamsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryAllFixatedParamsRequest",
            value: QueryAllFixatedParamsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryAllFixatedParamsRequest.typeUrl, QueryAllFixatedParamsRequest);
function createBaseQueryAllFixatedParamsResponse() {
    return {
        fixatedParams: [],
        pagination: undefined
    };
}
export const QueryAllFixatedParamsResponse = {
    typeUrl: "/lavanet.lava.epochstorage.QueryAllFixatedParamsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryAllFixatedParamsResponse.typeUrl || Array.isArray(o.fixatedParams) && (!o.fixatedParams.length || FixatedParams.is(o.fixatedParams[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryAllFixatedParamsResponse.typeUrl || Array.isArray(o.fixatedParams) && (!o.fixatedParams.length || FixatedParams.isSDK(o.fixatedParams[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryAllFixatedParamsResponse.typeUrl || Array.isArray(o.fixatedParams) && (!o.fixatedParams.length || FixatedParams.isAmino(o.fixatedParams[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.fixatedParams) {
            FixatedParams.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllFixatedParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.fixatedParams.push(FixatedParams.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            fixatedParams: Array.isArray(object?.fixatedParams) ? object.fixatedParams.map((e) => FixatedParams.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.fixatedParams) {
            obj.fixatedParams = message.fixatedParams.map(e => e ? FixatedParams.toJSON(e) : undefined);
        }
        else {
            obj.fixatedParams = [];
        }
        message.pagination !== undefined && (obj.pagination = message.pagination ? PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllFixatedParamsResponse();
        message.fixatedParams = object.fixatedParams?.map(e => FixatedParams.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryAllFixatedParamsResponse();
        message.fixatedParams = object.fixatedParams?.map(e => FixatedParams.fromAmino(e)) || [];
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = PageResponse.fromAmino(object.pagination);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.fixatedParams) {
            obj.fixatedParams = message.fixatedParams.map(e => e ? FixatedParams.toAmino(e) : undefined);
        }
        else {
            obj.fixatedParams = message.fixatedParams;
        }
        obj.pagination = message.pagination ? PageResponse.toAmino(message.pagination) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryAllFixatedParamsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryAllFixatedParamsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryAllFixatedParamsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryAllFixatedParamsResponse",
            value: QueryAllFixatedParamsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryAllFixatedParamsResponse.typeUrl, QueryAllFixatedParamsResponse);
function createBaseQueryProviderMetaDataRequest() {
    return {
        provider: ""
    };
}
export const QueryProviderMetaDataRequest = {
    typeUrl: "/lavanet.lava.epochstorage.QueryProviderMetaDataRequest",
    is(o) {
        return o && (o.$typeUrl === QueryProviderMetaDataRequest.typeUrl || typeof o.provider === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryProviderMetaDataRequest.typeUrl || typeof o.provider === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryProviderMetaDataRequest.typeUrl || typeof o.provider === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.provider !== "") {
            writer.uint32(10).string(message.provider);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProviderMetaDataRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.provider = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            provider: isSet(object.provider) ? String(object.provider) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.provider !== undefined && (obj.provider = message.provider);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProviderMetaDataRequest();
        message.provider = object.provider ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryProviderMetaDataRequest();
        if (object.provider !== undefined && object.provider !== null) {
            message.provider = object.provider;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.provider = message.provider === "" ? undefined : message.provider;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryProviderMetaDataRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryProviderMetaDataRequest.decode(message.value);
    },
    toProto(message) {
        return QueryProviderMetaDataRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryProviderMetaDataRequest",
            value: QueryProviderMetaDataRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryProviderMetaDataRequest.typeUrl, QueryProviderMetaDataRequest);
function createBaseQueryProviderMetaDataResponse() {
    return {
        metaData: []
    };
}
export const QueryProviderMetaDataResponse = {
    typeUrl: "/lavanet.lava.epochstorage.QueryProviderMetaDataResponse",
    is(o) {
        return o && (o.$typeUrl === QueryProviderMetaDataResponse.typeUrl || Array.isArray(o.metaData) && (!o.metaData.length || ProviderMetadata.is(o.metaData[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryProviderMetaDataResponse.typeUrl || Array.isArray(o.MetaData) && (!o.MetaData.length || ProviderMetadata.isSDK(o.MetaData[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryProviderMetaDataResponse.typeUrl || Array.isArray(o.MetaData) && (!o.MetaData.length || ProviderMetadata.isAmino(o.MetaData[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.metaData) {
            ProviderMetadata.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryProviderMetaDataResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.metaData.push(ProviderMetadata.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            metaData: Array.isArray(object?.metaData) ? object.metaData.map((e) => ProviderMetadata.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.metaData) {
            obj.metaData = message.metaData.map(e => e ? ProviderMetadata.toJSON(e) : undefined);
        }
        else {
            obj.metaData = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryProviderMetaDataResponse();
        message.metaData = object.metaData?.map(e => ProviderMetadata.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryProviderMetaDataResponse();
        message.metaData = object.MetaData?.map(e => ProviderMetadata.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.metaData) {
            obj.MetaData = message.metaData.map(e => e ? ProviderMetadata.toAmino(e) : undefined);
        }
        else {
            obj.MetaData = message.metaData;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryProviderMetaDataResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryProviderMetaDataResponse.decode(message.value);
    },
    toProto(message) {
        return QueryProviderMetaDataResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.epochstorage.QueryProviderMetaDataResponse",
            value: QueryProviderMetaDataResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryProviderMetaDataResponse.typeUrl, QueryProviderMetaDataResponse);
